import PublicLayout from "@/components/layouts/bootstrap/PublicLayout";
import Link from "next/link";
import { useState } from "react";
import { Image } from 'react-bootstrap';

export default function Industry()
{

    const questionsData = [
        { label: "Mental Health Industry", img: "/industry/mental-health-industry-polling.png" },
        { label: "Mental Health FIFO", img: "/industry/mental-health-fifo-polling.png" },
        { label: "Executive Leadership", img: "/industry/executive-leadership-polling.png" },
        { label: "High Performing Team - MGT", img: "/public/high-performing-team-polling.png" },
        { label: "Vision & Strategy", img: "/industry/education-polling-category.png" },
        { label: "Customer Market & Focus", img: "/public/workplace-culture-polling.png" },
        { label: "Growth & Scaling", img: "/public/business-growth-polling-background.png" },
        { label: "Innovation & Future Trends", img: "/public/innovation-trends-polling.png" },
        { label: "Resilience & Adaptability", img: "/industry/healthcare-polling-category.png" },
        { label: "Technology & Digital", img: "/industry/government-polling-category.png" },
        { label: "Financial & Operational Excellence", img: "/industry/events-polling-category.png" },
        { label: "Sustainability & Purpose", img: "/industry/consultants-polling-category.png" },
        { label: "Workplace Culture", img: "/public/workplace-culture-polling.png" },
    ];

    const middleIndex = Math.ceil(questionsData.length / 2);

    const leftItems = questionsData.slice(0, middleIndex);
    const rightItems = questionsData.slice(middleIndex);

    return (
        <>
            <section className="hero-reseller d-flex align-items-center text-white minHeightAuto">
                <div className="container hero-inner">
                    <div className="hero-copy">
                        <h1>Ask. See. Act.<br />All in Real Time.</h1>
                        <p className="mb-2">
                            No matter your industry, Instant Polls provides the <b>audience engagement</b> and <b> live data</b> leaders need to make smarter, faster decisions. From boardrooms to conferences, our <b>interactive platform</b> scales with your vision.
                        </p>

                    </div>

                    {/* <div className="row">
                        { 
                            questionsData.map((item, index) => (
                                <div className="col-3 fw-bold text-decoration-none hover-underline mt-2 cursorPointer" key={index}
                                    >
                                    <Link className="sm-btn-purple p-1 px-2 text-uppercase rounded" href={{ pathname: "/industry_questions_view", query: { from: item.label } }} > {item.label} </Link>
                                </div>
                            ))
                        }
                    </div> */}
                    <div className="row">

                        {/* LEFT COLUMN */}
                        <div className="col-3">
                            {leftItems.map((item, index) => (
                                <div
                                    className="fw-bold text-decoration-none hover-underline mt-2 cursorPointer"
                                    key={index}
                                >
                                    <Link
                                        className="sm-btn-purple p-1 px-2 text-uppercase rounded"
                                        href={{
                                            pathname: "/industry_questions_view",
                                            query: { from: item.label }
                                        }}
                                    >
                                        {item.label}
                                    </Link>
                                </div>
                            ))}
                        </div>

                        {/* CENTER COLUMN */}
                        <div className="col-5 d-flex align-items-center justify-content-center">
                            <div className="text-center">
                                <h2 className="industry-center-title">Click to View Sample of Expert Crafted Industry Questions</h2>
                               
                            </div>
                        </div>

                        {/* RIGHT COLUMN */}
                        <div className="col-4">
                            {rightItems.map((item, index) => (
                                <div
                                    className="fw-bold text-decoration-none hover-underline mt-2 cursorPointer text-align-end"
                                    key={index}
                                >
                                    <Link
                                        className="sm-btn-purple p-1 px-2 text-uppercase rounded"
                                        href={{
                                            pathname: "/industry_questions_view",
                                            query: { from: item.label }
                                        }}
                                    >
                                        {item.label}
                                    </Link>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </section>
            <section className="py-5">
                <div className="container industry">
                    <h2 className="mb-5 fw-bold text-teal text-center secondaryColor">Why Instant Polls Works in Any Industry</h2>
                    <div className="row g-4 justify-content-center">
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                            <Link href="/business_leadership">
                                <div className="industry-card shadow">
                                    <Image src="/industry/business-leaders-instant-polls.png" alt="Business Leaders" />
                                    <div className="industry-overlay">
                                        <p>Align executive teams, test strategies, and drive decisions with confidence</p>
                                    </div>
                                    <div className="industry-footer">Business & Leadership</div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                            <Link href="/education">
                                <div className="industry-card shadow">
                                    <Image src="/industry/education-instant-polls.png" alt="Education" />
                                    <div className="industry-overlay">
                                        <p>Engage students, gather instant feedback, and adapt teaching in real time.</p>
                                    </div>
                                    <div className="industry-footer">Education & Training</div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                            <Link href="/events">
                                <div className="industry-card shadow">
                                    <Image src="/industry/events-instant-polls.png" alt="Events" />
                                    <div className="industry-overlay">
                                        <p>Keep audiences engaged and show sponsors measurable ROI</p>
                                    </div>
                                    <div className="industry-footer">Events & Conferences</div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                            <Link href="/government">
                                <div className="industry-card shadow">
                                    <Image src="/industry/government-instant-polls.png" alt="Government" />
                                    <div className="industry-overlay">
                                        <p>Capture Sentiment, consult members, and increase transparency.</p>
                                    </div>
                                    <div className="industry-footer">Government & Associations</div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                            <Link href="/consulting">
                                <div className="industry-card shadow">
                                    <Image src="/industry/consultants-instant-polls.png" alt="Consultants" />
                                    <div className="industry-overlay">
                                        <p>Make workshops interactive, evidence-driven, and memorable</p>
                                    </div>
                                    <div className="industry-footer">Consulting & Professional Services</div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                            <Link href="/healthcare">
                                <div className="industry-card shadow">
                                    <Image src="/industry/healthcare-community-instant-polls.png" alt="Healthcare & Community" />
                                    <div className="industry-overlay">
                                        <p>Make workshops interactive, evidence-driven, and memorable</p>
                                    </div>
                                    <div className="industry-footer">Healthcare & Community</div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                            <Link href="/media">
                                <div className="industry-card shadow">
                                    <Image src="/industry/media-entertainment-instant-polls.png" alt="Media" />
                                    <div className="industry-overlay">
                                        <p>Captivate your audience.
                                            Shape the narrative</p>
                                    </div>
                                    <div className="industry-footer">Media</div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 text-center threecards patner">
                <div className="container fixed-width">
                    <div className="industry">
                        <h2 className="fw-bold text-teal secondaryColor">How Instant Polls Works</h2>
                        <p className="text-center">Run your first live poll in under 2 minutes.</p>
                    </div>
                    <div className="row  g-4">
                        <div className="col-md-4 col-sm-12 cardthree-works">
                            <div className="cardthree problem p-4 maxHeight">
                                <h5 className="fw-heads">Step 1</h5>
                                <p>Ask Better Questions:</p>
                                <p>Use our library of proven templates or write your own.</p>
                                <Link
                                    className="btn btn-info text-white mt-3 float-end font14"
                                    href="/industry_questions"
                                >
                                    VIEW EXPERT QUESTIONS
                                </Link>
                            </div>

                        </div>
                        <div className="col-md-4 col-sm-12 cardthree-works">
                            <div className="cardthree insight p-4 maxHeight">
                                <h5 className="fw-heads">Step 2</h5>
                                <p>Capture Feedback Instantly:</p>
                                <p>Share via link, QR code, Slack/Teams, or embed it on your site.</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-12 cardthree-works">
                            <div className="cardthree solution p-4 maxHeight">
                                <h5 className="fw-heads">Step 3</h5>
                                <p>Act With confidence:</p>
                                <p>See response update live, segment by audience group, and take immediate action.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="features py-5 bg-white" >
                <div className="container">
                    <div className="mb-5 industry">
                        <h2 className="fw-bold text-teal text-center secondaryColor" >How Instant Polls Works</h2> </div>

                    <div className="row g-4">
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="feature-card d-flex">
                                <div className="feature-icon">
                                    <Image src="/industry/icons/dashboard.png" alt="polls analytics dashboard icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="feature-title">Real-Time Dashboards</div>
                                    <p className="feature-text">Results stream in live, no refresh required.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="feature-card d-flex">
                                <div className="feature-icon">
                                    <Image src="/industry/icons/artificial-intelligence.png" alt="AI-powered polling intelligence icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="feature-title">AI-Powered Sentiment</div>
                                    <p className="feature-text">Understand tone and context, not just raw numbers.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="feature-card d-flex">
                                <div className="feature-icon">
                                    <Image src="/industry/icons/segmentation.png" alt="audience segmentation icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="feature-title">Segmentation</div>
                                    <p className="feature-text">Break results down by department, region, or demographics.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="feature-card d-flex">
                                <div className="feature-icon">
                                    <Image src="/industry/icons/system.png" alt="system integration icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="feature-title">Seamless Integrations</div>
                                    <p className="feature-text">Works with Teams, Slack, CRMs, and more.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="feature-card d-flex">
                                <div className="feature-icon">
                                    <Image src="/industry/icons/cyber-security-icon.png" alt="data security and privacy icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="feature-title">Enterprise-Grade Security</div>
                                    <p className="feature-text">Anonymous by default, encrypted end-to-end.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="feature-card d-flex">
                                <div className="feature-icon">
                                    <Image src="/industry/icons/outline.png" alt="reporting and insights icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="feature-title">White-Label Branding</div>
                                    <p className="feature-text">Brand every poll as your own.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="py-5 commonLatestBgv" >
                <div className="container testimonials">
                    <h2 className="mb-5 text-purple text-white">Hear From Our Users</h2>
                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="quotes">
                                <p>“Instant Polls changed how we run leadership meetings. We get clarity in minutes instead of waiting on surveys.”</p>
                                <cite>Managing Director, Professional Services</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="quotes">
                                <p>“As an event organiser, I finally have live engagement metrics to show sponsors real ROI.”</p>
                                <cite>Event Manager</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="quotes">
                                <p>“Our students love it. Real-time feedback makes learning more interactive.”</p>
                                <cite>University Lecturer</cite>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 final-ctai bg-white">
                <div className="container d-lg-flex cta-poll align-items-center">
                    <div className="col-lg-7">
                        <div className="final-copy">
                            <h2 className="secondaryColor">Ready to Lead Smarter <br /> in Your Industry?</h2>
                            <p>No matter where you work, Instant Polls unlocks clarity, trust, and engagement.</p>
                            <Link href="/contact" className="button btn-purple">Talk to Sales</Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

Industry.getLayout = (page) => <PublicLayout>{page}</PublicLayout>;